import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Button } from 'antd'
import { Icon, Flex, Header } from 'govwell-ui'

import { useUpdateUserIsAIStaffMemberMutation } from 'src/fetch/users'
import useDisclosure from 'src/hooks/use-disclosure'
import {
  useAmIAIStaffMember,
  useMyOrgId,
  useMyUser,
  useRefetchAppState,
} from 'src/layouts/AppStateContextLayout/utils'
import AddTeamMemberModal from 'src/pages/AIAssistantSettingsPage/AddTeamMemberModal'
import AITeamTable from 'src/pages/AIAssistantSettingsPage/AITeamTable'
import { QueryKey } from 'src/utils/queryClient'

const Team = () => {
  const queryClient = useQueryClient()
  const { mutateAsync: updateUserIsAIStaffMember } = useUpdateUserIsAIStaffMemberMutation()
  const userId = useMyUser()?.id
  const organizationId = useMyOrgId()
  const isAIStaffMember = useAmIAIStaffMember()
  const refetchAppState = useRefetchAppState()
  const handleAddMyselfToAITeam = useCallback(async () => {
    if (!userId) {
      return
    }
    await updateUserIsAIStaffMember({ id: userId, isAIStaffMember: true, organizationId })
    await refetchAppState?.() // hide the "Join the AI team" button
    await queryClient.invalidateQueries({ queryKey: [QueryKey.AIStaffMembers] }) // update AITeamTable
  }, [userId, organizationId, updateUserIsAIStaffMember, refetchAppState, queryClient])

  const addTeamMemberModalState = useDisclosure()

  return (
    <>
      <Flex direction="column" gap={2}>
        <Flex justify="space-between" width="100%">
          <Flex>
            <Header title="Team Members" />
          </Flex>
          <Flex gap={1} justify="end">
            {!isAIStaffMember && (
              <Button icon={<Icon.FaComment />} onClick={handleAddMyselfToAITeam}>
                Join the AI team
              </Button>
            )}
            <Button icon={<Icon.FaPlus />} type="primary" onClick={addTeamMemberModalState.open}>
              Add to team
            </Button>
          </Flex>
        </Flex>
        <AITeamTable />
      </Flex>
      {addTeamMemberModalState.isOpen && (
        <AddTeamMemberModal onClose={addTeamMemberModalState.close} />
      )}
    </>
  )
}

export default React.memo(Team)
